document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.c-tab');

  tabs.forEach(tab => {
    const faqButton = tab.querySelector('.c-tab__header');
    const faqContent = tab.querySelector('.c-tab__content');

    tab.classList.add('is-hidden');

    faqButton.addEventListener('click', function () {
      if (tab.classList.contains('is-hidden')) {
        tab.classList.remove('is-hidden');
        tab.classList.add('is-open');
      } else {
        tab.classList.add('is-hidden');
        tab.classList.remove('is-open');
      }
    });
  });
});